import React from 'react';
import bookOpened from './book-open.svg';
import styles from './InfoLink.scss'

const LinkWithIcon = ({ link, text, openInNewTab, className, style,icon }) => {
  const handleClick = () => {
    if (openInNewTab) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <a
      href={link}
      className={className ?? 'imageLink'}
      style={style}
      onClick={(e) => {
        e.preventDefault();
        handleClick();
      }}
      target={openInNewTab ? '_blank' : '_self'}
      rel={openInNewTab ? 'noopener noreferrer' : ''}
    >
      <img src={icon ?? bookOpened} alt="image-link" className={'imageLink'}/>
      <span>{text}</span>
    </a>
  );
};

export default LinkWithIcon;
